import React, { Component } from "react";
import { Portal } from "react-portal";

export default class ProductFabrics extends Component {
	
	state = { isOpen: false, currentIndex:false };

	handleToggle = (event) => {
		event.preventDefault();
    	this.setState({ isOpen: !this.state.isOpen });
  	}
  	
  	handleZoom = (event) => {
		event.preventDefault();
		let index = parseInt(event.target.getAttribute('data-index'));
		if (index === this.state.currentIndex) {
			this.setState({ currentIndex: false });
		} else {
			this.setState({ currentIndex: index });
		}
  	}
  	
	render () {
		
		if (this.props.fabric) {
			
			if (this.props.fabric.length > 0) {
				
				const fabrics = this.props.fabric.map((fabric,i) =>
					<div key={i} className={`c-fabrics__swatch state-toggle ${this.state.currentIndex === i ? "state-active" : ""}`} onClick={this.handleZoom} data-index={i}>
						{fabric.swatch_src && 
							<div className="c-fabrics__swatch__inner" data-index={i}>
								<img alt={fabric.name} src={fabric.swatch_src} />
							</div>
						}
						{fabric.swatch_hex &&
							<div className="c-fabrics__swatch__inner" data-index={i} style={{ backgroundColor: fabric.swatch_hex }}></div>
						}
						<p className="c-fabrics__swatch__text" data-index={i}>{ fabric.name }</p>
					</div>	
				)
					
				return (
					<>
						<a href="#" className="c-fabric-select" onClick={this.handleToggle}>
							<p className="c-paragraph">This lamp shade fabric/colour is Customisable</p>
							<p className="c-paragraph c-paragraph--xsmall c-paragraph--light">Choose from one of our { this.props.fabric.length } Fabrics or supply your own</p>
							<p className="c-paragraph c-paragraph--small">Find out more ></p>
						</a>
						<Portal>
							<div className={'c-fabrics ' + (this.state.isOpen ? 'state-open' : "")}>
								<a href="#" className="c-fabrics__overlay" onClick={this.handleToggle}></a>
								<div className="c-fabrics__panel">
									<div className="c-fabrics__panel__inner">
										<a href="#" className="c-fabrics__close" onClick={this.handleToggle}></a>
										<div>
											<h3 className="c-paragraph">Fabric Options</h3>
											<h5 className="c-paragraph c-paragraph--xsmall c-paragraph--light c-paragraph--space">Please enquire about these fabric options</h5>
											<p className="c-paragraph">Choose from our range of fabrics below</p>
											<p className="c-paragraph c-paragraph--space">Recover an existing shade in our fabrics or your own</p>
										</div>
										<div className="c-fabrics__swatches">
											{fabrics}
										</div>
									</div>
								</div>
							</div>
						</Portal>
					</>
				)
			} else {
				return false;
			}
		} else {
			return false;
		}
	}
}